<div class="portrait-compat">
  <p>{{t 'portraitModeWarning'}}</p>
  <div class="btn btn-default" data-close>{{t 'okButton'}}</div>
</div>